import React from 'react';
import classnames from 'classnames';

import styles from './styles.module.scss';

export enum BackgroundType {
  Default = 'default',
  Simple = 'simple',
  OmitXs = 'omitXs',
}

interface Props {
  type: BackgroundType;
  className?: string;
}

const Background: React.FC<Props> = ({ children, type = BackgroundType.Default, className }) => {
  return (
    <div className={classnames(styles.bg, { [styles[type]]: true }, className)}>{children}</div>
  );
};

export default Background;
